import { getToken } from "helper/common";
import {
    CLEAR_STATE_DETAILS,
    CLEAR_STATE_LIST,
    SET_STATE_DETAILS,
    SET_STATE_FILTER_DATA,
    SET_STATE_LIST,
    STATE_CREATE_DIALOG_CLOSE,
    STATE_CREATE_DIALOG_OPEN,
    STATE_CREATE_ERROR,
    STATE_CREATE_ERROR_CLEAR,
    STATE_CREATE_PENDING,
    STATE_DETAILS_ERROR,
    STATE_DETAILS_ERROR_CLEAR,
    STATE_DETAILS_PENDING,
    STATE_EDIT_DIALOG_CLOSE,
    STATE_EDIT_DIALOG_OPEN,
    STATE_EDIT_ERROR,
    STATE_EDIT_ERROR_CLEAR,
    STATE_EDIT_PENDING,
    STATE_FILTER_DIALOG_CLOSE,
    STATE_FILTER_DIALOG_OPEN,
    STATE_LIST_ERROR,
    STATE_LIST_ERROR_CLEAR,
    STATE_LIST_PENDING,
} from "./constants";
import agent from "store/service/agent";
import { openSnackbar } from "store/slices/snackbar";
import { trimmedValues } from "helper/trim";
import { encodeObjectValues } from "helper/encodeData";

//-----------------------------|| LIST ||---------------------------------------------------------------
export const setStateList = (stateList) => ({
    type: SET_STATE_LIST,
    payload: { stateList }
});

export const clearStateList = () => ({
    type: CLEAR_STATE_LIST,
});

export const stateListPending = () => ({
    type: STATE_LIST_PENDING
});

export const stateListError = (errorMessage) => ({
    type: STATE_LIST_ERROR,
    payload: { errorMessage }
});

export const stateListErrorClear = () => ({
    type: STATE_LIST_ERROR_CLEAR
});

export const getStateList = (page, pageSize, sortOrder, sortDirection, filter) => (dispatch) => {
    const encodeFilters = encodeObjectValues({ ...filter })
    dispatch(stateListPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.stateConfiguration.getStateList(accessToken, page, pageSize, sortOrder, sortDirection, encodeFilters)
            .then((stateList) => {
                dispatch(setStateList(stateList));
                dispatch(stateListErrorClear());
                dispatch(stateEditErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(stateListError(message));
                }
                else {
                    dispatch(stateListError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const openStateFilterDialog = () => ({
    type: STATE_FILTER_DIALOG_OPEN
});

export const closeStateFilterDialog = () => ({
    type: STATE_FILTER_DIALOG_CLOSE
});

export const setStateFilteredData = (filter) => ({
    type: SET_STATE_FILTER_DATA,
    payload: { filter },
});

//-----------------------------|| DETAILS ||---------------------------------------------------------------
export const setStateDetails = (stateDetails) => ({
    type: SET_STATE_DETAILS,
    payload: { stateDetails }
});

export const clearStateDetails = () => ({
    type: CLEAR_STATE_DETAILS,
});

export const stateDetailsPending = () => ({
    type: STATE_DETAILS_PENDING
});

export const stateDetailsError = (errorMessage) => ({
    type: STATE_DETAILS_ERROR,
    payload: { errorMessage }
});

export const stateDetailsErrorClear = () => ({
    type: STATE_DETAILS_ERROR_CLEAR
});

export const getStateDetails = (id) => (dispatch) => {
    dispatch(stateDetailsPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.stateConfiguration.getStateDetails(accessToken, id)
            .then((stateDetails) => {
                dispatch(setStateDetails(stateDetails));
                dispatch(stateDetailsErrorClear());
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(stateDetailsError(message));
                }
                else {
                    dispatch(stateDetailsError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| CREATE ||---------------------------------------------------------------
export const openStateCreateDialog = () => ({
    type: STATE_CREATE_DIALOG_OPEN
});

export const closeStateCreateDialog = () => ({
    type: STATE_CREATE_DIALOG_CLOSE
});

export const stateCreatePending = () => ({
    type: STATE_CREATE_PENDING
});

export const stateCreateError = (errorMessage) => ({
    type: STATE_CREATE_ERROR,
    payload: { errorMessage }
});

export const stateCreateErrorClear = () => ({
    type: STATE_CREATE_ERROR_CLEAR
});

export const stateCreate = (formData, filter, paginationData) => (dispatch) => {
    const { page, pageSize, sortOrder, sortDirection } = paginationData || {};
    const dataToSend = trimmedValues({ ...formData })
    dispatch(stateCreatePending());
    return getToken(dispatch).then((accessToken) => {
        return agent.stateConfiguration.stateCreate(accessToken, dataToSend)
            .then(() => {
                dispatch(getStateList(page, pageSize, sortOrder, sortDirection, filter));
                dispatch(stateCreateErrorClear());
                dispatch(closeStateCreateDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'State/Export successfully created.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(stateCreateError(message));
                }
                else {
                    dispatch(stateCreateError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const openStateEditDialog = () => ({
    type: STATE_EDIT_DIALOG_OPEN
});

export const closeStateEditDialog = () => ({
    type: STATE_EDIT_DIALOG_CLOSE
});

export const stateEditPending = () => ({
    type: STATE_EDIT_PENDING
});

export const stateEditError = (errorMessage) => ({
    type: STATE_EDIT_ERROR,
    payload: { errorMessage }
});

export const stateEditErrorClear = () => ({
    type: STATE_EDIT_ERROR_CLEAR
});

export const stateEdit = (formData) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(stateEditPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.stateConfiguration.stateEdit(accessToken, dataToSend)
            .then(() => {
                dispatch(getStateDetails(formData?.id));
                dispatch(stateEditErrorClear());
                dispatch(closeStateEditDialog());
                dispatch(openSnackbar({
                    open: true,
                    message: 'State/Export details successfully updated.',
                    variant: 'alert',
                    close: false
                }))
                return Promise.resolve(true);
            })
            .catch((err) => {
                if (err?.status) {
                    let message;
                    const { response } = err;
                    if (response?.body) {
                        message = response.body.error?.message;
                    }
                    else if (response?.text) {
                        message = response.text;
                    }
                    else {
                        message = null;
                    }
                    dispatch(stateEditError(message));
                }
                else {
                    dispatch(stateEditError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })
}
